module.exports = __webpack_public_path__ + "img/dept-1.f0b5daf1.svg";